import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";

export default function LegalPage({ type }) {
    const { t } = useLang();
    const isPrivacy = type === "privacy";
    const title = isPrivacy ? t.legal.privacyTitle : t.legal.impressumTitle;
    const body = isPrivacy ? t.legal.privacyBody : t.legal.impressumBody;
    const path = isPrivacy ? "/legal/privacy" : "/legal/impressum";
    const pathKey = isPrivacy ? "privacy" : "impressum";

    return (
        <main data-testid={`page-legal-${pathKey}`} className="bg-white">
            <SEO pathKey={pathKey} path={path} />
            <section className="pt-28 lg:pt-36 pb-12 blueprint-bg">
                <div className="mx-auto max-w-3xl px-6 lg:px-10">
                    <Reveal>
                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-steel-600 hover:text-navy transition-colors"
                        >
                            <ArrowLeft className="h-3 w-3" /> OTHRYX · Home
                        </Link>
                        <div className="mt-4 font-mono-tech text-[11px] uppercase tracking-[0.3em] text-steel-600">
                            Legal & Compliance
                        </div>
                        <h1 className="font-display mt-4 text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tighter text-navy leading-[0.95]">
                            {title}
                        </h1>
                    </Reveal>
                </div>
            </section>

            <section className="pb-24">
                <div className="mx-auto max-w-3xl px-6 lg:px-10">
                    <Reveal delay={120}>
                        <article className="border-t border-steel-100 pt-10">
                            <p className="text-steel-800 leading-relaxed whitespace-pre-line">
                                {body}
                            </p>
                        </article>
                    </Reveal>
                </div>
            </section>
        </main>
    );
}
